// Order chat view with messages containing long unbreakable URLs — useful for
// verifying the chat layout (feed scrolling, composer placement, bubble
// wrapping) across window sizes without an authenticated transaction.
import TransactionPanel from './TransactionPanel';
import {
  createUser,
  createCurrentUser,
  createMessage,
  createTransaction,
  createListing,
  createTxTransition,
} from '../../util/test-data';
import {
  TRANSITION_REQUEST_PAYMENT,
  TRANSITION_CONFIRM_PAYMENT,
  TX_TRANSITION_ACTOR_CUSTOMER,
} from '../../util/transaction';

const noop = () => null;

const customer = createUser('customer-user', {
  profile: {
    displayName: 'Miikka F',
    abbreviatedName: 'MF',
    publicData: { account_role: 'customer' },
  },
});
const provider = createUser('provider-user', {
  profile: {
    displayName: 'Sanna S',
    abbreviatedName: 'SS',
    publicData: { account_role: 'freelancer' },
  },
});
const currentUser = createCurrentUser('customer-user', {
  profile: {
    firstName: 'Miikka',
    lastName: 'F',
    displayName: 'Miikka F',
    abbreviatedName: 'MF',
    publicData: { account_role: 'customer' },
  },
});

const longUrlText =
  'Näyttää hyvältä! :) Tässä vielä pitkiä linkkejä testiksi:\n\n' +
  'https://www.rakennuslehti.fi/wp-content/uploads/2020/06/fredriksberg_konepaja-2560x1440.jpg\n' +
  'https://i.media.fi/incoming/p48z9j/7496268.jpg/alternates/FREE_1440/7496268.jpg\n' +
  'https://kaupunginosat.fi/roihuvuori/herttoniemen-metroaseman-uusi-kaava-hyvaksytty-4-2025/';

const makeMessages = () => [
  createMessage(
    'msg1',
    {
      content: 'Moikka! Kiitos paljon hakemuksesta. :)',
      createdAt: new Date(Date.UTC(2026, 7, 17, 12, 29)),
    },
    { sender: provider }
  ),
  createMessage(
    'msg2',
    { content: longUrlText, createdAt: new Date(Date.UTC(2026, 7, 18, 13, 48)) },
    { sender: customer }
  ),
  createMessage(
    'msg3',
    {
      content: 'Hei, liitteenä on. T., Kristiina.',
      createdAt: new Date(Date.UTC(2026, 7, 18, 15, 20)),
    },
    { sender: provider }
  ),
];

const transaction = createTransaction({
  id: 'tx-example',
  customer,
  provider,
  listing: createListing('listing-x'),
  lastTransition: TRANSITION_CONFIRM_PAYMENT,
  transitions: [
    createTxTransition({
      createdAt: new Date(Date.UTC(2026, 7, 16, 8, 10)),
      by: TX_TRANSITION_ACTOR_CUSTOMER,
      transition: TRANSITION_REQUEST_PAYMENT,
    }),
    createTxTransition({
      createdAt: new Date(Date.UTC(2026, 7, 16, 8, 11)),
      by: TX_TRANSITION_ACTOR_CUSTOMER,
      transition: TRANSITION_CONFIRM_PAYMENT,
    }),
  ],
});
transaction.attributes.protectedData = {};
transaction.attributes.processName = 'flex-default-process';
transaction.attributes.processVersion = 99;

const baseProps = {
  transactionRole: 'customer',
  currentUser,
  transaction,
  messages: makeMessages(),
  totalMessagePages: 1,
  oldestMessagePageFetched: 1,
  fetchMessagesInProgress: false,
  sendMessageInProgress: false,
  sendReviewInProgress: false,
  onUploadAttachment: noop,
  onRemoveAttachment: noop,
  onDownloadAttachment: noop,
  onOpenAttachment: noop,
  onFetchAttachmentPreview: noop,
  onManageDisableScrolling: noop,
  onShowMoreMessages: noop,
  onSendMessage: noop,
  onSendReview: noop,
  onSubmitBookingRequest: noop,
  onAcceptSale: noop,
  onDeclineSale: noop,
  acceptInProgress: false,
  declineInProgress: false,
  onFetchTransactionLineItems: noop,
  fetchLineItemsInProgress: false,
  onSubmitEnquiryCustomer: noop,
  onSubmitAcceptBidRequest: noop,
  onSendCustomOffer: noop,
  onAcceptProjectBid: noop,
  onDeclineProjectBid: noop,
  onJobReady: noop,
  onJobReadyPro: noop,
  onReleaseFunds: noop,
  onJobDoneReleaseFunds: noop,
  onAcceptProJob: noop,
  onUpdateProfile: noop,
};

export const OrderChat = {
  component: TransactionPanel,
  props: baseProps,
  group: 'transaction',
};
